// extracted by mini-css-extract-plugin
export default {"container":"Day_container__xpc5O","noCollection":"Day_noCollection__UxCLO"};